import { render } from "./invite-users.vue?vue&type=template&id=cb2726b6&lang=pug"
import script from "./invite-users.vue?vue&type=script&lang=js"
export * from "./invite-users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__